import { ArrowLeft, Sparkles } from "lucide-react";

export function UserMealFormHeader({
  heading,
  setShowConfirmCancelModal,
  onOpenAiFillModal,
}) {
  return (
    <div className="bg-white border-b border-gray-200 px-8 py-6">
      <button
        onClick={() => setShowConfirmCancelModal(true)}
        className="flex items-center gap-2 text-gray-600 hover:text-gray-900 mb-4 transition-colors"
      >
        <ArrowLeft className="w-5 h-5" />
        <span className="text-sm font-medium">Back to Recipes</span>
      </button>
      <div className="flex items-center justify-between gap-4">
        <h1 className="text-3xl font-semibold text-gray-900">{heading}</h1>
        {onOpenAiFillModal && (
          <button
            type="button"
            onClick={onOpenAiFillModal}
            className="flex items-center gap-1.5 px-3 py-1.5 text-sm font-medium text-gray-700 border border-gray-200 rounded-lg hover:bg-gray-50 transition-colors"
          >
            <Sparkles className="w-4 h-4" />
            Fill with AI
          </button>
        )}
      </div>
    </div>
  );
}
